
const digest = 'f8f8084d3b05dda30f94935279fee5081aaa80208d755a2d11dead1b37b6ce1c';
const css = `._commandMenuItemIcon_1qab6_1 {
  margin-right: var(--spacer-1);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItemIcon":"_commandMenuItemIcon_1qab6_1"};
export { css, digest };
  